/* import __COLOCATED_TEMPLATE__ from './content.hbs.js'; */
import Component from '@glimmer/component';
export default class FlyOptionCardContent extends Component {
  get isVisible() {
    return this.args.isVisible ?? true;
  }
}